// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"styles_tableHeader__2xnGR"};